import { buildMessageHandler, buildCloseHandler } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
function open(x) {
    // code available only in debug builds is excluded from coverage
    /* istanbul ignore next */
    if (process.env.NODE_ENV === "development") {
        console.warn("Opened socket:", x);
    }
}
export function sportsSocketConnectionHandlers(rqFormatter, rsFormatter) {
    return {
        open,
        close: buildCloseHandler(ConnectionNames.sports, SDQuerySubscribersStore),
        message: buildMessageHandler(SDQuerySubscribersStore),
        requestFormatter: rqFormatter,
        responseFormatter: rsFormatter,
    };
}
//# sourceMappingURL=sportsSocketConnectionHandlers.js.map